import { EdgesGeometry, Group, LineSegments, PlaneGeometry } from 'three';

import { edgeMat, metals } from './Materials';

export default class Doors {
  constructor(wardrobeConfig, gltf) {
    this.gltf = gltf;
    this.wardrobeConfig = wardrobeConfig;
    const aSafo = wardrobeConfig.safo.split('/');
    this.type = aSafo[0];
    this.makeDoors();
  }

  makeDoors() {
    this.newDoors = new Group();
    this.newDoors.name = 'Doors';

    this.newFronts = new Group();
    this.newFronts.name = 'Fronts';

    this.newFrontEdges = new Group();
    this.newFrontEdges.name = 'FrontEdges';

    this.newLus = new Group();
    this.newLus.name = 'Lus';

    this.newLusEdges = new Group();
    this.newLusEdges.name = 'LusEdges';

    this.newRams_L = new Group();
    this.newRams_L.name = 'Rams_L';

    this.newRams_R = new Group();
    this.newRams_R.name = 'Rams_R';

    this.newRails = new Group();
    this.newRails.name = 'Rails';

    this.newOutlines = new Group();
    this.newOutlines.name = 'Outlines';

    this.newHandlesL = new Group();
    this.newHandlesL.name = 'Handles';
    this.newHandlesL.scale.set(100, 100, 100);
    this.newHandlesL.position.set(50, this.wardrobeConfig.dimensions.y / 2, 2);

    this.newHandlesR = new Group();
    this.newHandlesR.name = 'Handles';
    this.newHandlesR.scale.set(100, 100, 100);
    this.newHandlesR.position.set(50, this.wardrobeConfig.dimensions.y / 2, 2);

    let handleDistance;

    if (this.type === 'F57-SZF1DR') {
      handleDistance = 0.45;
    } else if (this.type === 'F57-SZF1DL') {
      handleDistance = 0.04;
    } else {
      handleDistance = 0.03;
    }

    this.gltf.traverse(obj => {
      switch (obj.name) {
        case 'Front':
          for (let i = 0; i < 2; i++) {
            for (let j = 0; j < 4; j++) {
              const newFront = obj.clone();
              newFront.name = 'Front_' + i + '_' + j;
              this.newFronts.add(newFront);

              const newOutline = this.getOutline();
              newOutline.name = 'Outline-Front_' + i + '_' + j;
              this.newOutlines.add(newOutline);
              newOutline.visible = false;
            }
          }
          this.newDoors.add(this.newFronts);
          break;
        case 'Front_Edge':
          for (let i = 0; i < 2; i++) {
            for (let j = 0; j < 4; j++) {
              const newEdge = obj.clone();
              newEdge.material = edgeMat;
              newEdge.name = 'FrontEdge_' + i + '_' + j;
              this.newFrontEdges.add(newEdge);
              if (this.wardrobeConfig.dimensions.y < 240 && j === 3) {
                newEdge.visible = false;
              }
            }
          }
          break;
        case 'Rail_Top':
          this.Rail_Top = obj.clone();
          this.Rail_Top.name = 'Rail_Top';
          this.newRails.add(this.Rail_Top);
          this.Rail_Top.material = metals.SRE;
          break;
        case 'Rail_Bottom':
          this.Rail_Bottom = obj.clone();
          this.Rail_Bottom.material = metals.SRE;
          this.Rail_Bottom.name = 'Rail_Bottom';
          this.newRails.add(this.Rail_Bottom);
          break;
        case 'Rail_Left':
          this.Rail_left_L = obj.clone();
          this.Rail_left_L.name = 'Rail_left_L';
          this.Rail_left_R = obj.clone();
          this.Rail_left_R.name = 'Rail_left_R';
          this.Rail_left_L.material = metals.SRE;
          this.Rail_left_R.material = metals.SRE;
          this.newRails.add(this.Rail_left_L);
          this.newRails.add(this.Rail_left_R);
          break;
        case 'Rail_Right':
          this.Rail_right_L = obj.clone();
          this.Rail_right_L.name = 'Rail_right_L';
          this.Rail_right_R = obj.clone();
          this.Rail_right_R.name = 'Rail_right_R';
          this.Rail_right_L.material = metals.SRE;
          this.Rail_right_R.material = metals.SRE;
          this.newRails.add(this.Rail_right_L);
          this.newRails.add(this.Rail_right_R);
          break;
        case 'LUS': // 8,9
          for (let i = 0; i < 2; i++) {
            const newLus = obj.clone();
            newLus.name = 'Lus_' + i + '_0';
            this.newFronts.add(newLus);
          }
          break;
        case 'LUS_Edge': // 10,11
          for (let i = 0; i < 2; i++) {
            const newEdge = obj.clone();
            // newEdge.material = edgeMat;
            newEdge.material = edgeMat;
            newEdge.name = 'LusEdge_' + i + '_0';
            this.newFrontEdges.add(newEdge);
          }
          break;
        case 'RAM_Left': // 12,13
          for (let i = 0; i < 2; i++) {
            const newRamL = obj.clone();
            newRamL.name = 'Ram_' + i + '_0';
            this.newFronts.add(newRamL);
          }
          break;
        case 'RAM_Right':
          for (let i = 0; i < 2; i++) {
            const newRamR = obj.clone();
            newRamR.name = 'Ram_' + i + '_1';
            this.newFronts.add(newRamR);
          }
          break;
        case 'RAM_Back':
          for (let i = 0; i < 2; i++) {
            const newRamK = obj.clone();
            newRamK.name = 'Ram_' + i + '_2';
            this.newFronts.add(newRamK);
          }
          break;
        case 'RAM_Top':
          for (let i = 0; i < 2; i++) {
            const newRamT = obj.clone();
            newRamT.name = 'Ram_' + i + '_3';
            this.newFronts.add(newRamT);
          }
          for (let i = 0; i < 2; i++) {
            const newRamM = obj.clone();
            newRamM.name = 'Ram_' + i + '_4';
            this.newFronts.add(newRamM);
          }
          for (let i = 0; i < 2; i++) {
            const newRamB = obj.clone();
            newRamB.name = 'Ram_' + i + '_5';
            this.newFronts.add(newRamB);
          }
          break;
        case 'Galka':
          const newHandle = obj.clone();
          newHandle.name = 'C475';
          newHandle.position.x = -handleDistance;
          newHandle.visible = false;
          this.newHandlesL.add(newHandle);

          const newHandle2 = obj.clone();
          newHandle2.name = 'C475';
          newHandle2.position.x = handleDistance;
          newHandle2.visible = false;
          this.newHandlesR.add(newHandle2);
          break;
        case 'Galka2':
          const newHandle3 = obj.clone();
          newHandle3.name = 'C415';
          newHandle3.position.x = -handleDistance;
          newHandle3.visible = false;
          this.newHandlesL.add(newHandle3);

          const newHandle4 = obj.clone();
          newHandle4.position.x = handleDistance;
          newHandle4.material = metals.SRE;
          newHandle4.name = 'C415';
          newHandle4.visible = false;
          this.newHandlesR.add(newHandle4);
          break;
        case 'Uchwyt':
          const newHandle5 = obj.clone();
          newHandle5.position.x = -handleDistance;
          newHandle5.name = 'C501/1';
          newHandle5.visible = false;
          this.newHandlesL.add(newHandle5);

          const newHandle6 = obj.clone();
          newHandle6.rotation.z = Math.PI;
          newHandle6.position.x = handleDistance;
          newHandle6.name = 'C501/1';
          newHandle6.visible = false;
          this.newHandlesR.add(newHandle6);
          break;
        case 'Uchwyt2':
          const newHandle7 = obj.clone();
          newHandle7.position.x = -handleDistance;
          newHandle7.name = 'C365/4';
          newHandle7.visible = false;
          this.newHandlesL.add(newHandle7);

          const newHandle8 = obj.clone();
          newHandle8.position.x = handleDistance;
          newHandle8.name = 'C365/4';
          newHandle8.visible = false;
          this.newHandlesR.add(newHandle8);
          break;
        case 'Uchwyt3':
          const newHandle9 = obj.clone();
          newHandle9.position.x = -handleDistance;
          newHandle9.name = 'C365/8';
          newHandle9.visible = false;
          this.newHandlesL.add(newHandle9);

          const newHandle10 = obj.clone();
          newHandle10.position.x = handleDistance;
          newHandle10.name = 'C365/8';
          newHandle10.visible = false;
          this.newHandlesR.add(newHandle10);
          break;
        case 'Uchwyt4':
          const newHandle11 = obj.clone();
          newHandle11.position.x = -handleDistance;
          newHandle11.material = metals.SRE;

          newHandle11.name = 'ZN1';
          newHandle11.visible = false;
          this.newHandlesL.add(newHandle11);
          break;
        case 'Uchwyt5':
          const newHandle12 = obj.clone();
          newHandle12.position.x = -handleDistance;
          newHandle12.material = metals.SRE;
          newHandle12.name = 'ZN21';
          newHandle12.visible = false;
          this.newHandlesL.add(newHandle12);
          break;
        case 'UchwytMetal':
          const newHandle13 = obj.clone();
          newHandle13.position.x = -handleDistance;
          newHandle13.name = 'C558';
          newHandle13.visible = false;
          this.newHandlesL.add(newHandle13);

          const newHandle14 = obj.clone();
          newHandle14.position.x = handleDistance;
          newHandle14.name = 'C558';
          newHandle14.visible = false;
          this.newHandlesR.add(newHandle14);
          break;
        case 'UchwytSkora':
          const newHandle15 = obj.clone();
          newHandle15.position.setX(this.getPosition(obj.name, 'l', 'x'));
          newHandle15.position.setZ(this.getPosition(obj.name, 'l', 'z'));
          newHandle15.name = 'C542';
          newHandle15.part = 1;
          newHandle15.visible = false;
          this.newHandlesL.add(newHandle15);

          const newHandle16 = obj.clone();
          newHandle16.position.setX(this.getPosition(obj.name, 'r', 'x'));
          newHandle16.position.setZ(this.getPosition(obj.name, 'r', 'z'));
          newHandle16.name = 'C542';
          newHandle16.part = 1;
          newHandle16.visible = false;
          this.newHandlesR.add(newHandle16);
          break;
        case 'UchwytPasek':
          const newHandle17 = obj.clone();
          newHandle17.position.setX(this.getPosition(obj.name, 'l', 'x'));
          newHandle17.position.setZ(this.getPosition(obj.name, 'l', 'z'));
          newHandle17.name = 'C542';
          newHandle17.part = 0;
          newHandle17.visible = false;
          this.newHandlesL.add(newHandle17);

          const newHandle18 = obj.clone();
          newHandle18.position.setX(this.getPosition(obj.name, 'r', 'x'));
          newHandle18.position.setZ(this.getPosition(obj.name, 'r', 'z'));
          newHandle18.name = 'C542';
          newHandle18.part = 0;
          newHandle18.visible = false;
          this.newHandlesR.add(newHandle18);
          break;
        case 'UchwytC513':
          const newHandle19 = obj.clone();
          newHandle19.position.x = -handleDistance;
          newHandle19.name = 'C513';
          newHandle19.visible = false;
          this.newHandlesL.add(newHandle19);

          const newHandle20 = obj.clone();
          newHandle20.position.x = handleDistance;
          newHandle20.name = 'C513';
          newHandle20.visible = false;
          this.newHandlesR.add(newHandle20);
          break;
        case 'UchwytC560':
          const newHandle21 = obj.clone();
          newHandle21.position.setX(this.getPosition(obj.name, 'l', 'x'));
          newHandle21.position.setZ(this.getPosition(obj.name, 'l', 'z'));
          newHandle21.name = 'C560/1';
          newHandle21.visible = false;
          this.newHandlesL.add(newHandle21);

          const newHandle22 = obj.clone();
          newHandle22.position.setX(this.getPosition(obj.name, 'r', 'x'));
          newHandle22.position.setZ(this.getPosition(obj.name, 'r', 'z'));
          newHandle22.name = 'C560/1';
          newHandle22.visible = false;
          this.newHandlesR.add(newHandle22);
          break;
        case 'C603':
          const newHandle23 = obj.clone();
          newHandle23.position.x = -handleDistance;
          newHandle23.name = 'C603';
          newHandle23.visible = false;
          this.newHandlesL.add(newHandle23);

          const newHandle24 = obj.clone();
          newHandle24.position.x = handleDistance;
          newHandle24.name = 'C603';
          newHandle24.visible = false;
          this.newHandlesR.add(newHandle24);
          break;
        case 'C604':
          const newHandle25 = obj.clone();
          newHandle25.position.x = -handleDistance;
          newHandle25.name = 'C604/1';
          newHandle25.visible = false;
          this.newHandlesL.add(newHandle25);

          const newHandle26 = obj.clone();
          newHandle26.rotation.z = Math.PI;
          newHandle26.position.x = handleDistance;
          newHandle26.name = 'C604/1';
          newHandle26.visible = false;
          this.newHandlesR.add(newHandle26);
          break;
        case 'C601':
          const newHandle27 = obj.clone();
          newHandle27.position.x = -handleDistance;
          newHandle27.name = 'C601';
          newHandle27.visible = false;
          this.newHandlesL.add(newHandle27);

          const newHandle28 = obj.clone();
          newHandle28.position.x = handleDistance;
          newHandle28.name = 'C601';
          newHandle28.visible = false;
          this.newHandlesR.add(newHandle28);
          break;
        case 'C627_1':
          const newHandle29 = obj.clone();
          newHandle29.position.setX(this.getPosition(obj.name, 'l', 'x'));
          newHandle29.position.setZ(this.getPosition(obj.name, 'l', 'z'));
          newHandle29.name = 'C627/1';
          newHandle29.visible = false;
          this.newHandlesL.add(newHandle29);

          const newHandle30 = obj.clone();
          newHandle30.rotation.z = Math.PI;
          newHandle30.position.setX(this.getPosition(obj.name, 'r', 'x'));
          newHandle30.position.setZ(this.getPosition(obj.name, 'r', 'z'));
          newHandle30.name = 'C627/1';
          newHandle30.visible = false;

          this.newHandlesR.add(newHandle30);
          break;
        case 'C627_2':
          const newHandle31 = obj.clone();
          newHandle31.position.setX(this.getPosition(obj.name, 'l', 'x'));
          newHandle31.position.setZ(this.getPosition(obj.name, 'l', 'z'));
          newHandle31.name = 'C627/2';
          newHandle31.visible = false;
          this.newHandlesL.add(newHandle31);

          const newHandle32 = obj.clone();
          newHandle32.rotation.z = Math.PI;
          newHandle32.position.setX(this.getPosition(obj.name, 'r', 'x'));
          newHandle32.position.setZ(this.getPosition(obj.name, 'r', 'z'));
          newHandle32.name = 'C627/2';
          newHandle32.visible = false;
          this.newHandlesR.add(newHandle32);
          break;
        case 'C627_3':
          const newHandle33 = obj.clone();
          newHandle33.position.setX(this.getPosition(obj.name, 'l', 'x'));
          newHandle33.position.setZ(this.getPosition(obj.name, 'l', 'z'));
          newHandle33.position.setY(this.getPosition(obj.name, 'l', 'y'));
          newHandle33.name = 'C627/3';
          newHandle33.visible = false;
          this.newHandlesL.add(newHandle33);

          const newHandle34 = obj.clone();
          newHandle34.rotation.z = Math.PI;
          newHandle34.position.setX(this.getPosition(obj.name, 'r', 'x'));
          newHandle34.position.setZ(this.getPosition(obj.name, 'r', 'z'));
          newHandle34.position.setY(this.getPosition(obj.name, 'r', 'y'));
          newHandle34.name = 'C627/3';
          newHandle34.visible = false;
          this.newHandlesR.add(newHandle34);
          break;
        case 'C628':
          const newHandle35 = obj.clone();
          newHandle35.position.x = -handleDistance;
          newHandle35.name = 'C628';
          newHandle35.visible = false;
          this.newHandlesL.add(newHandle35);

          const newHandle36 = obj.clone();
          newHandle36.position.x = handleDistance;
          newHandle36.name = 'C628';
          newHandle36.visible = false;
          this.newHandlesR.add(newHandle36);
          break;
        case 'C630':
          const newHandle37 = obj.clone();
          newHandle37.position.setX(this.getPosition(obj.name, 'l', 'x'));
          newHandle37.position.setZ(this.getPosition(obj.name, 'l', 'z'));

          if (this.type === 'F57-SZF1DR') {
            newHandle37.rotation.y = Math.PI;
            newHandle37.rotation.z = (-Math.PI / 180) * 30;
          } else {
            newHandle37.rotation.z = (Math.PI / 180) * 50;
          }

          newHandle37.name = 'C630/1';
          newHandle37.visible = false;
          this.newHandlesL.add(newHandle37);

          const newHandle38 = obj.clone();
          newHandle38.position.setX(this.getPosition(obj.name, 'r', 'x'));
          newHandle38.position.setZ(this.getPosition(obj.name, 'r', 'z'));
          if (this.type === 'F57-SZF1DR') {
            newHandle38.rotation.y = Math.PI;
            newHandle38.rotation.z = (Math.PI / 180) * 50;
          } else {
            newHandle38.rotation.y = Math.PI;
          }

          newHandle38.name = 'C630/1';
          newHandle38.visible = false;
          this.newHandlesR.add(newHandle38);
          break;
        case 'C631':
          const newHandle39 = obj.clone();
          newHandle39.position.setX(this.getPosition(obj.name, 'l', 'x'));
          newHandle39.position.setZ(this.getPosition(obj.name, 'l', 'z'));
          newHandle39.name = 'C631';
          newHandle39.visible = false;
          if (this.type === 'F57-SZF1DR') {
            newHandle39.rotation.z = Math.PI;
          }
          this.newHandlesL.add(newHandle39);

          const newHandle40 = obj.clone();

          newHandle40.position.setX(this.getPosition(obj.name, 'r', 'x'));
          newHandle40.position.setZ(this.getPosition(obj.name, 'r', 'z'));
          if (this.type === 'F57-SZF1DR') {
            newHandle40.rotation.z = Math.PI * 2;
          } else {
            newHandle40.rotation.z = Math.PI;
          }
          newHandle40.name = 'C631';
          newHandle40.visible = false;
          this.newHandlesR.add(newHandle40);
          break;
        default:
      }
    });
    this.newDoors.add(this.newFronts);
    this.newDoors.add(this.newLus);
    this.newDoors.add(this.newLusEdges);
    this.newDoors.add(this.newRails);
    this.newDoors.add(this.newRams_L);
    this.newDoors.add(this.newRams_R);
    this.newDoors.add(this.newOutlines);
    this.newDoors.add(this.newFrontEdges);
    this.newDoors.add(this.newHandlesL);
    this.newDoors.add(this.newHandlesR);
  }

  getPosition(objName, side, prop) {
    let wardrobeType = 'other';
    if (this.type === 'F57-SZF1DR' || this.type === 'F57-SZF1DL' || this.type === 'F57-SZFN1D') {
      wardrobeType = this.type;
    }
    const positionMap = {
      UchwytC560: {
        r: {
          'F57-SZF1DL': { x: 0.04, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.03, y: 0, z: 0.05 },
          other: { x: -0.2, y: 0, z: 0.5 },
        },
        l: {
          'F57-SZF1DL': { x: -0.04, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.03, y: 0, z: 0.05 },
          other: { x: -0.27, y: 0, z: 0.5 },
        },
      },
      UchwytSkora: {
        r: {
          'F57-SZF1DL': { x: 0.04, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.02, y: 0, z: 0.05 },
          other: { x: -0.235, y: 0, z: 0.53 },
        },
        l: {
          'F57-SZF1DL': { x: -0.04, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.02, y: 0, z: 0.05 },
          other: { x: -0.3, y: 0, z: 0.53 },
        },
      },
      UchwytPasek: {
        r: {
          'F57-SZF1DL': { x: -0.06, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.045, y: 0, z: 0.02 },
          other: { x: -0.235, y: 0, z: 0.5 },
        },
        l: {
          'F57-SZF1DL': { x: -0.06, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.045, y: 0, z: 0.02 },
          other: { x: -0.3, y: 0, z: 0.5 },
        },
      },
      C604: {
        r: {
          'F57-SZF1DL': { x: -0.06, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.045, y: 0, z: 0.02 },
          other: { x: -0.235, y: 0, z: 0.5 },
        },
        l: {
          'F57-SZF1DL': { x: -0.06, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.045, y: 0, z: 0.02 },
          other: { x: -0.3, y: 0, z: 0.5 },
        },
      },
      C627_1: {
        r: {
          'F57-SZF1DL': { x: -0.05, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.045, y: 0, z: 0.02 },
          other: { x: -0.21, y: 0, z: 0.5 },
        },
        l: {
          'F57-SZF1DL': { x: -0.05, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.03, y: 0, z: 0.02 },
          other: { x: -0.09, y: 0, z: 0.11 },
        },
      },
      C627_2: {
        r: {
          'F57-SZF1DL': { x: -0.05, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.008, y: 0, z: 0.02 },
          other: { x: -0.21, y: 0, z: 0.5 },
        },
        l: {
          'F57-SZF1DL': { x: -0.05, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.03, y: 0, z: 0.02 },
          other: { x: -0.09, y: 0, z: 0.11 },
        },
      },
      C627_3: {
        r: {
          'F57-SZF1DL': { x: -0.05, y: -0.79, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: -0.8, z: 0.03 },
          'F57-SZFN1D': { x: -0.03, y: -0.8, z: 0.02 },
          other: { x: -0.21, y: -0.8, z: 0.5 },
        },
        l: {
          'F57-SZF1DL': { x: -0.05, y: -0.79, z: 0.03 },
          'F57-SZF1DR': { x: -0.45, y: -0.8, z: 0.03 },
          'F57-SZFN1D': { x: -0.03, y: -0.8, z: 0.02 },
          other: { x: -0.09, y: -0.78, z: 0.11 },
        },
      },
      C630: {
        r: {
          'F57-SZF1DL': { x: 0, y: 0, z: 0.05 },
          'F57-SZF1DR': { x: -0.49, y: 0, z: 0.01 },
          'F57-SZFN1D': { x: -0.01, y: 0, z: 0.01 },
          other: { x: -0.25, y: 0, z: 0.57 },
        },
        l: {
          'F57-SZF1DL': { x: -0.05, y: 0, z: 0.05 },
          'F57-SZF1DR': { x: -0.49, y: 0, z: 0.01 },
          'F57-SZFN1D': { x: -0.02, y: 0, z: 0.01 },
          other: { x: -0.29, y: 0, z: 0.5 },
        },
        l50: {
          'F57-SZF1DL': { x: 0, y: 0, z: 0.05 },
          'F57-SZF1DR': { x: -0.49, y: 0, z: 0.01 },
          'F57-SZFN1D': { x: -0.01, y: 0, z: 0.01 },
          other: { x: -0.31, y: 0, z: 0.5 },
        },
      },
      C631: {
        r: {
          'F57-SZF1DL': { x: -0.06, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.42, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: -0.045, y: 0, z: 0.02 },
          other: { x: -0.235, y: 0, z: 0.5 },
        },
        l: {
          'F57-SZF1DL': { x: -0.03, y: 0, z: 0.03 },
          'F57-SZF1DR': { x: -0.42, y: 0, z: 0.03 },
          'F57-SZFN1D': { x: 0.022, y: 0, z: 0.15 },
          other: { x: -0.275, y: 0, z: 0.5 },
        },
      },
    };
    if (positionMap[objName][side + this.wardrobeConfig.dimensions.x] !== undefined) {
      return positionMap[objName][side + this.wardrobeConfig.dimensions.x][wardrobeType][prop] || 0;
    }
    return positionMap[objName][side][wardrobeType][prop] || 0;
  }

  getOutline() {
    var geometry = new PlaneGeometry(1, 1);
    let geo = new EdgesGeometry(geometry);
    var outline = new LineSegments(geo);
    outline.material.color.setHex(0xff0000);
    return outline;
  }

  setDoors(wardrobeConfig) {
    const dimensions = wardrobeConfig.dimensions;

    this.type = wardrobeConfig.safo.split('/')[0];

    const frontHeight =
      this.wardrobeConfig.dimensions.y > 218
        ? this.wardrobeConfig.dimensions.y / 4 - 1
        : this.wardrobeConfig.dimensions.y / 3 - 1;

    if (wardrobeConfig.is_hinged === false) {
      this.newHandlesL.visible = false;
      this.newHandlesR.visible = false;

      this.newFronts.children.forEach((front, index) => {
        if (index < 8) {
          const outline = this.newOutlines.children[index];
          const edge = this.newFrontEdges.children[index];

          front.scale.set(dimensions.x / 2 - 2, frontHeight, 100);
          edge.scale.set(dimensions.x / 2 - 2, frontHeight, 100);
          if (index > 3 && index < 8) {
            front.position.x = 3;
            front.position.y = (index - 4) * frontHeight + 1.5;
            front.position.z = -6;
            edge.position.x = 3;
            edge.position.y = (index - 4) * frontHeight + 1.5;
            edge.position.z = -6;
            outline.scale.set(dimensions.x / 2 - 6, frontHeight, 100);
            outline.position.y = (index - 4) * frontHeight + 2 + frontHeight / 2;
            outline.position.x = dimensions.x / 4;
          } else {
            front.position.x = dimensions.x / 2;
            front.position.y = index * frontHeight + 1.5;
            front.position.z = -2.5;
            edge.position.x = dimensions.x / 2;
            edge.position.y = index * frontHeight + 1.5;
            edge.position.z = -2.5;
            outline.scale.set(dimensions.x / 2 - 6, frontHeight, 100);
            outline.position.y = index * frontHeight + 2 + frontHeight / 2;
            outline.position.x = dimensions.x - dimensions.x / 4 - 1;
          }
          if (dimensions.y < 240 && (index === 3 || index === 7)) {
            front.visible = false;
          } else {
            front.visible = true;
          }
        } else {
          front.visible = false;
          if (index < 10) {
            this.newFrontEdges.children[index].visible = false;
          }
        }
      });

      if (this.newRails.children.length > 0) {
        this.newRails.visible = true;
        this.Rail_Top.position.set(0, dimensions.y - 2, 0.5);
        this.Rail_Top.scale.set(dimensions.x - 2, 100, 100);
        this.Rail_Bottom.position.y = 0;
        this.Rail_Bottom.scale.set(dimensions.x - 2, 100, 100);

        this.Rail_left_L.position.set(2, 1, -6.5);
        this.Rail_left_L.scale.set(100, dimensions.y - 2, 100);
        this.Rail_left_R.position.set(dimensions.x / 2 - 0.5, 2, -2);
        this.Rail_left_R.scale.set(100, dimensions.y - 5, 100);
        this.Rail_right_L.position.set(dimensions.x - 2, 2, -2);
        this.Rail_right_L.scale.set(100, dimensions.y - 3, 100);
        this.Rail_right_R.position.set(dimensions.x / 2 + 3, 2, -6.5);
        this.Rail_right_R.scale.set(100, dimensions.y - 2, 100);
      }
      this.newRams_L.visible = false;
      this.newRams_R.visible = false;
      this.newLus.visible = false;
      this.newLusEdges.visible = false;
    } else {
      /* HINGED */
      this.newRails.visible = false;
      this.newHandlesL.visible = true;
      this.newHandlesR.visible = true;

      for (let i = 0; i < 8; i++) {
        this.newFronts.children[i].visible = false;
        this.newFrontEdges.children[i].visible = false;
      }
      wardrobeConfig.fronts.forEach((front, index) => {
        if (!!front && front.constructor.name === 'Object') {
          let frontWidth = 10;
          let xPosition = 0;
          let handleShift = -3;

          frontWidth = wardrobeConfig.doors_sizes[index];

          switch (index) {
            case 0:
              xPosition = 0;
              break;
            case 1:
              handleShift = 4;
              xPosition = wardrobeConfig.doors_sizes[0];
              break;
            default:
              break;
          }

          if (front.types.hasOwnProperty(14)) {
            // ten typ zawsze jest przypisany do ramiaków

            this.newFronts.children.forEach(front => {
              let aName = front.name.split('_');
              if (aName[0] === 'Ram' && parseInt(aName[1]) === index) {
                front.visible = true;
              }
            });

            this.newFronts.children[8 + index].visible = false;

            this.newFronts.children[10 + index].scale.set(100, dimensions.y - 0.5, 100);
            this.newFronts.children[10 + index].position.x = xPosition + frontWidth;
            this.newFronts.children[12 + index].scale.set(100, dimensions.y - 0.5, 100);
            this.newFronts.children[12 + index].position.x = xPosition;
            this.newFronts.children[14 + index].scale.set(frontWidth - 2, dimensions.y - 2, 100);
            this.newFronts.children[14 + index].position.x = xPosition;
            this.newFronts.children[16 + index].scale.set(frontWidth - 7, 100, 100);
            this.newFronts.children[16 + index].position.x = xPosition + 4;
            this.newFronts.children[16 + index].position.y = dimensions.y - 0.5;
            this.newFronts.children[18 + index].scale.set(frontWidth - 7, 100, 100);
            this.newFronts.children[18 + index].position.x = xPosition + 4;
            this.newFronts.children[18 + index].position.y = 8;
            this.newFronts.children[20 + index].scale.set(frontWidth - 7, 100, 100);
            this.newFronts.children[20 + index].position.x = xPosition + 4;
            this.newFronts.children[20 + index].position.y = dimensions.y / 2 + 3.5;

            this.newFrontEdges.children[8 + index].visible = false;
          } else {
            this.newFronts.children.forEach(front => {
              let aName = front.name.split('_');
              if (aName[0] === 'Ram' && parseInt(aName[1]) === index) {
                front.visible = false;
              }
            });

            this.newFronts.children[8 + index].scale.set(frontWidth, dimensions.y - 0.5, 100);
            this.newFrontEdges.children[8 + index].scale.set(frontWidth, dimensions.y - 0.5, 100);

            this.newFronts.children[8 + index].position.x = xPosition;
            this.newFrontEdges.children[8 + index].position.x = xPosition;
            this.newFronts.children[8 + index].visible = true;
            this.newFrontEdges.children[8 + index].visible = true;
          }

          this.newOutlines.children[index * 4].scale.set(frontWidth - 1, dimensions.y - 2, 100);

          this.newOutlines.children[index * 4].position.set(
            frontWidth / 2 + xPosition,
            dimensions.y / 2,
            4,
          );

          if (
            dimensions.x < 75 ||
            this.type === 'F57-SZFN1D' ||
            this.type === 'F57-SZF1DR' ||
            this.type === 'F57-SZF1DL'
          ) {
            this.newHandlesR.visible = false;
            this.newFronts.children[11].visible = false;
            this.newFronts.children[13].visible = false;
            this.newFronts.children[15].visible = false;
            this.newFronts.children[17].visible = false;
            this.newFronts.children[19].visible = false;
            this.newFronts.children[21].visible = false;
            this.newOutlines.children[4].visible = false;

            //SZK
            this.newFronts.children[9].visible = false;
            this.newFrontEdges.children[9].visible = false;
          }
        }
        let handle = null;
        if (index === 0) {
          handle = this.getHandleFromSafo(wardrobeConfig.handles.left);
        } else {
          handle = this.getHandleFromSafo(wardrobeConfig.handles.right);
        }
        if (index === 0) {
          this.newHandlesL.children.forEach(handleMesh => {
            if (this.isShouldShow(handleMesh, handle)) {
              this.setMaterial(handleMesh, handle);
              if (handleMesh.name === 'C627/3') {
                this.newHandlesL.scale.set(100, 107, 100);
              } else {
                this.newHandlesL.scale.set(100, 100, 100);
              }
              handleMesh.visible = true;
            } else {
              handleMesh.visible = false;
            }
          });
        } else {
          this.newHandlesR.children.forEach(handleMesh => {
            if (this.isShouldShow(handleMesh, handle)) {
              this.setMaterial(handleMesh, handle);
              if (handleMesh.name === 'C627/3') {
                this.newHandlesL.scale.set(100, 107, 100);
              } else {
                this.newHandlesL.scale.set(100, 100, 100);
              }
              handleMesh.visible = true;
            } else {
              handleMesh.visible = false;
            }
          });
        }
      });
    }
    switch (this.type) {
      case 'F57-SZFN1D':
        this.newDoors.rotation.y = (-Math.PI / 180) * 45;
        this.newDoors.position.x = 1;
        this.newDoors.position.z = -1;
        this.newRams_R.visible = false;
        break;
      case 'F57-SZF1DL':
        this.newRams_R.visible = false;
        break;
      case 'F57-SZF1DR':
        this.newDoors.rotation.y = (-Math.PI / 180) * 90;
        this.newDoors.position.x = 3;
        this.newRams_L.visible = true;
        this.newRams_R.visible = false;
        break;
      default:
        this.newDoors.rotation.y = 0;
        break;
    }
  }

  getHandleFromSafo(wardrobeConfigHandles) {
    if (wardrobeConfigHandles?.safo) {
      let safoHandle = wardrobeConfigHandles.safo;
      if (safoHandle.match('UCHWYT_') !== null) {
        safoHandle = safoHandle.replace('UCHWYT_', 'UCHWYT/');
      }
      let [...safoHandleParts] = safoHandle.split('/');
      safoHandleParts.shift();
      let modelMaterial = safoHandleParts.join('/');
      let [model, color] = modelMaterial.split('-');

      return {
        model: model,
        color: color,
      };
    }
    return null;
  }

  isShouldShow(handleMesh, handle) {
    return handleMesh.name === handle?.model;
  }

  setMaterial(handleMesh, handle) {
    const color = handle?.color;
    const part = handleMesh.part || 0;
    if (color !== null) {
      let [...colors] = color.split('/');
      if (handleMesh.type === 'Object3D') {
        handleMesh.children[0].material = metals[colors[part]];
      } else {
        handleMesh.material = metals[colors[part]];
      }
    }
  }

  openDoors(how) {
    this.newDoors.visible = how;
  }

  getDoors() {
    return this.newDoors;
  }

  getHandles() {
    return this.newRails;
  }

  getOutlines() {
    return this.newOutlines;
  }
}
